module.exports = __webpack_public_path__ + "static/media/audio.a900dde.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio.mp3
// module id = Mrhs
// module chunks = 5